import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Observable } from "rxjs";

// Import Model
import { apiLink } from "../../../constant/api-link";
import { ImageAppBackOfficeModel } from "../../../model/builk/image-app/image-app.model";
import { ImageAppFilterModel } from "../../../model/builk/image-app/image-app-filter.model";
import { AddImageModel } from "../../../model/builk/image-app/add-image.model";
import { LocalStorageService } from "angular-2-local-storage";
import { UpdateStatusImageAppModel } from "../../../model/builk/image-app/update-status-image-app.mpde";
import { UpdateImageAppModel } from "../../../model/builk/image-app/update-image-app.model";

@Injectable({
    providedIn: "root"
  })
export class ImageAppService {

    constructor(
        private http: HttpClient,
        private localStorageService: LocalStorageService
    ) { }

    sub: any;

    getImageAppBackOffice(filterModel: ImageAppFilterModel): Observable<ImageAppBackOfficeModel> {

        const url = apiLink.getImageAppBackOffice;
        const headers = new HttpHeaders({ "Content-Type": "application/json" });

        return this.http.post<ImageAppBackOfficeModel>(url, filterModel, { headers });
    }
    addImage(model: AddImageModel): Observable<number> {

        const url = apiLink.addImageAppBackOffice;
        // const headers = new HttpHeaders({ "Content-Type": "application/json" });
        let form = new FormData();
        
        form.append('title', model.name);
        form.append('linkUrl', model.linkUrl);
        form.append('userEmail', this.localStorageService.get("userEmail"));
        form.append('file', model.file);
        return this.http.post<number>(url, form);
    }
    
    updateStatusImageApp(model: UpdateStatusImageAppModel): Observable<number> {

        const url = apiLink.updateStatusImageApp;
        const headers = new HttpHeaders({ "Content-Type": "application/json" });

        return this.http.put<number>(url, model, { headers });
    }

    updateImage(model: UpdateImageAppModel): Observable<number> {

        const url = apiLink.editImageApp;
        // const headers = new HttpHeaders({ "Content-Type": "application/json" });
        let form = new FormData();
        
        form.append('title', model.title);
        form.append('linkUrl', model.linkUrl);
        form.append('userEmail', this.localStorageService.get("userEmail"));
        form.append('file', model.file);
        form.append('isUploadFile', model.isUploadFile? '1': '0');
        form.append('imageAppSurrKey', model.imageAppSurrKey.toString());
        return this.http.put<number>(url, form);
    }
}
